import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import {
  getHashValue,
  PrivateLayout,
  ResourcesAdditionalResourcesTab,
  ResourcesContactInformationTab,
  ResourcesSpecialtyPharmacyTab
} from '../components';
import { AnyType } from '../interfaces';
import { tenancyFeatureSelector, AppRootState } from '../redux';
import { extractCaseUrl, getConfigurationDataKey } from '../utils';
import { Journal } from 'react-bootstrap-icons';

const contactInfomationTabKey = '#contactInfomation';
const specialtyPharmacyTaKey = '#specialtyPharmacy';
const additionalResourcesTabKey = '#additionalResources';

export const ResourcesView = () => {
  const history = useHistory();
  const isMultiDrugEnabled = useSelector(
    (state: AppRootState) =>
      (((state.app?.entities?.features as AnyType) ?? {})[getConfigurationDataKey('isMultiDrugEnabled')] as AnyType)
        ?.data?.enabled
  );
  const resourcesConfig: AnyType = useSelector<AnyType>(
    tenancyFeatureSelector(getConfigurationDataKey('resources.tabs'))
  );

  const hashValue: string | undefined = extractCaseUrl(useLocation())?.hashValue;
  const defaultActiveKey = hashValue ? getHashValue(hashValue) : additionalResourcesTabKey;

  const onTabSelect = (eventKey: string | null) => {
    if (!eventKey) return;

    history.push(eventKey);
  };

  return (
    <PrivateLayout pageTitle='Resources' pageIcon={<i className={`fas fa-light fa-books-medical`}></i>}>
      <Tabs className='tabs-primary' defaultActiveKey={defaultActiveKey} mountOnEnter onSelect={onTabSelect}>
        {resourcesConfig?.contactInfo?.enabled && isMultiDrugEnabled && (
          <Tab className='pt-3 site-background' eventKey={contactInfomationTabKey} title='Contact Information'>
            <ResourcesContactInformationTab contactInfoConfig={resourcesConfig?.contactInfo} />
          </Tab>
        )}
        {resourcesConfig?.specialtyPharmacy?.enabled && isMultiDrugEnabled && (
          <Tab
            className='pt-3 site-background'
            eventKey={specialtyPharmacyTaKey}
            title='Speciality Pharmacy Information'>
            <ResourcesSpecialtyPharmacyTab specialtyPharmacyConfig={resourcesConfig?.specialtyPharmacy} />
          </Tab>
        )}
        {resourcesConfig?.additionalResources?.enabled && (
          <Tab className='pt-3 site-background' eventKey={additionalResourcesTabKey} title='Additional Resources'>
            <ResourcesAdditionalResourcesTab />
          </Tab>
        )}
      </Tabs>
    </PrivateLayout>
  );
};
